/**
 * Dataset (single-boat) BUTTONS explore page.
 * No source selector: a dataset is one boat. The whole day is read on load and the LEDs follow the playhead.
 */
import ButtonsReportSection from "../../../../components/reports/ButtonsReportSection";

export default function DatasetButtonsPage(props: Record<string, unknown>) {
  return <ButtonsReportSection {...props} variant="single" />;
}
